<app-error-handler onlyFor="view">
  <app-statuswidget [objRecordDetails]="objRecordDetails"></app-statuswidget>
  <div class="row">
    <div class="col-sm-12">
      <app-viewform [objRecordDetails]="objRecordDetails"></app-viewform>
    </div>
  </div>
  </app-error-handler>